import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'rfq-site-map-dialog',
  templateUrl: './rfq-site-map-dialog.component.html'
})
export class RfqSiteMapDialogComponent {
  coordinates: [number, number];
  isUserDrag: boolean;
  @Output() coordinatesChanged = new EventEmitter<[number, number]>();

  constructor(
    public dialogRef: MatDialogRef<RfqSiteMapDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {    
    this.coordinates = data.coordinates;
  }

  onCoordinatesChanged(coords: [number, number]) {
    this.coordinates = coords;
    this.isUserDrag = true;
    this.coordinatesChanged.emit(coords);
  }

  onClose() {
    this.dialogRef.close(this.coordinates);
  }
} 
